import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: 'Are the designs actually usable by a tattoo artist?',
  answer: 'Yes! Our AI is trained specifically on tattoo art, meaning it understands line weights, shading techniques, and contrast needed for actual skin. You can download high-res versions to show your artist as a perfect reference.'
}, {
  question: 'How does the AR Try-On work?',
  answer: "Using your phone's camera, the app projects the generated design onto your skin. It tracks your body's contours so you can move your arm or leg and see how the tattoo warps and flows naturally."
}, {
  question: 'Can I use my own photos as inspiration?',
  answer: 'Absolutely. With TATAN Pro, you can upload any photo—a portrait, a pet, or a landscape—and the AI will reinterpret it into a specific tattoo style like fine line or traditional.'
}, {
  question: 'Do I own the designs I generate?',
  answer: 'Yes, you have full personal rights to use any design you generate for your own tattoos. However, commercial redistribution of the digital files is restricted.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-24 bg-white/[0.02] border-y border-white/5" data-id="element-12">
      <div className="max-w-3xl mx-auto px-6" data-id="element-13">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-5xl font-black tracking-tighter text-center mb-12" data-id="element-14">
          Frequently asked questions
        </motion.h2>

        <div className="space-y-4" data-id="element-15">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="border border-white/10 rounded-2xl bg-black overflow-hidden" data-id="element-16">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-17">
                  <span className="font-bold text-lg pr-8" data-id="element-18">{faq.question}</span>
                  <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform duration-300 shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-19" />
                </button>
                <AnimatePresence data-id="element-20">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-21">
                      <div className="px-6 pb-6 text-gray-400 leading-relaxed" data-id="element-22">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}